"use client";

import { useAuth } from "@pex/auth/client";
import { identifyUser } from "@pex/observability/client";
import { useEffect } from "react";

/**
 * Tells the error SDK who the current user is so Better Stack reports
 * affected-user counts instead of "0 affected users".
 *
 * Unlike analytics identity this is NOT gated on cookie consent — error
 * monitoring is operational (legitimate interest), and only the user's account
 * id is attached. Email is deliberately withheld: Better Stack has no binding
 * DPA, so an opaque UUID is the most we should send (GH #1085).
 */
export function ObservabilityIdentity() {
  const { user } = useAuth();

  useEffect(() => {
    identifyUser(user ? { id: user.id } : null);
  }, [user]);

  return null;
}
